import { AppState } from "../interfaces/app";
import { Done } from "../../components/Done";


export const screens = {
  WELCOME: 0,
  AUTH: 1,
  RULES: 3,
  GAME: 4,
  PROMO_CODE: 5,
  FINISHED: 7,
  FINISHED_NO_TEXT: 8,
  DONE: 9,
  EMPTY: 10,
  STUB: 11
}

export const initialStateData: AppState = {
  showAlreadyHave: false,
  codeText: "",
  showConfirm: false,
  showRules: false,
  agreed: false,
  code: 0,
  count: 0,
  email: "",
  screen: screens.EMPTY,
  username: ""
}